import React, { useState } from 'react';
import { Tabs, Typography, Card, Row, Col } from 'antd';
import { useTranslationWithNamespace } from '../hooks/useTranslationWithNamespace';
import IndexerTestTab from '../components/debug/IndexerTestTab';

const { Title } = Typography;

/**
 * Debug page component with various debugging tools
 */
const DebugPage: React.FC = () => {
  const { t: commonT } = useTranslationWithNamespace('common');
  const { t: debugT } = useTranslationWithNamespace('debug');
  const [activeTab, setActiveTab] = useState('indexer-test');

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <div>
      <Row gutter={[16, 16]} align="middle">
        <Col flex="auto">
          <Title level={2}>{debugT('title', 'Debug Tools')}</Title>
        </Col>
      </Row>

      <Card>
        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={[
            {
              key: 'indexer-test',
              label: debugT('tabs.indexerTest', 'Indexer Test'),
              children: <IndexerTestTab />
            }
            // Additional debug tabs can be added here in the future
          ]}
        />
      </Card>
    </div>
  );
};

export default DebugPage;
